import "../styles/globals.css";
import '../components/editor/TiptapTheme.scss'
import type { AppProps } from "next/app";
import { Navbar } from "components/Navbar";
import Head from "next/head";
import '../styles/react-menu.css';
// import "@szhsin/react-menu/dist/core.css";
import Modal from 'react-modal'
import 'react-toastify/dist/ReactToastify.css';
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer } from "react-toastify";
import { CookiesProvider } from "react-cookie";
import { QueryClient, QueryClientProvider, useQueryClient } from "react-query";
import { useEffect, useState } from "react";
import * as Tooltip from "@radix-ui/react-tooltip";
import { SkeletonTheme } from "react-loading-skeleton";
import { ReactQueryDevtools } from 'react-query/devtools'
import { NewlyRegisteredPopup } from "components/NewlyRegisteredPopup";
import { AuthProvider } from "api/auth";
import { StyleProvider as AntdStyleProvider, px2remTransformer } from '@ant-design/cssinjs';
import { IconProvider as AntdIconProvider } from '@ant-design/icons';
import { ConfigProvider as AntdConfigProvider, ThemeConfig as AntdThemeConfig } from 'antd'
import ruRU from 'antd/locale/ru_RU';

// import { AuthProvider } from "hooks/auth";
Modal.setAppElement('#__next')

// export function getInitialProps(): any {
//   return {

//   }
// }


function App({ Component, pageProps }: AppProps) {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 10,
      }
    }
  })

  const changelogState = useState(false)

  const [bigscreen, setBigscreen] = useState(false)

  useEffect(() => {
    window.addEventListener('resize', () => {
      const query = window.matchMedia('(min-width: 2100px)')
      setBigscreen(query.matches)
    })
  }, [])



  const px2rem = px2remTransformer({
    // rootValue: 16,
  })

  const antdTheme: AntdThemeConfig = {
    token: {
      fontSize: bigscreen ? 17 : 15,
      // colorPrimary: '#065F27',
      colorPrimary: '#0C8CE9',
      borderRadius: 10,
      // controlHeight
    },
    components: {
      TreeSelect: {
        titleHeight: 36,
      },
    },
    cssVar: true,
  }

  return (
    <>
      <Head key="head">
        <title>Research Helper</title>
        <meta name="keywords" content="medicine, articles, медицина, статьи, кардиология, ропниз, нмиц тпм" />
        <meta name="description" content="Первая в России платформа, созданная для подачи, экспертизы и публикации научно-методической медицинской информации в одно касание" />
        <meta name="og:title" content="Research Helper" />
        <meta name="og:description" content="Первая в России платформа, созданная для подачи, экспертизы и публикации научно-методической медицинской информации в одно касание" />
        <meta name="theme-color" content="#065f27" />
      </Head>
      <ToastContainer position="top-right" hideProgressBar={true}
        autoClose={2000}

        style={{ /* top: 24 * 4 */ /* 3 */ }} />
      <CookiesProvider>
        <AuthProvider>
          <QueryClientProvider client={client}>
              <Tooltip.Provider delayDuration={300}>
                <SkeletonTheme baseColor="#dddddd" highlightColor="#e8e8e8" duration={3}>
                  <AntdStyleProvider transformers={[px2rem]} layer>
                    <AntdConfigProvider theme={antdTheme} locale={ruRU}>
                      <NewlyRegisteredPopup key="newly-registered-popup" />
                      <Component {...pageProps} />
                    </AntdConfigProvider>
                  </AntdStyleProvider>
                </SkeletonTheme>
              </Tooltip.Provider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </AuthProvider>
      </CookiesProvider>

    </>
  );
}

export default App
